module.exports = __webpack_public_path__ + "img/database.17d48d95.svg";